import { createCommand } from '@commander-js/extra-typings';
import type { CommandServices } from '@wix/cli-command-contract';
import { translationPullCommand } from './translation-pull.js';
import { translationPushCommand } from './translation-push.js';

export const translationCommand = (
  services: CommandServices,
  cliVersion: string
) => {
  return createCommand('translation')
    .description('Work with site translations')
    .addCommand(translationPullCommand(services, cliVersion))
    .addCommand(translationPushCommand(services, cliVersion));
};
